import Input from "./inputProp";


export default function FormInput({ divClass, astriskClass, label, name, type, placeholder, value, onChange, required, minLength, maxLength, className, errorMessage }) {
    
    return(

        <div className={`inputs ${divClass}`}>
            <label className="label">
                {label} <span className='asterisk'> <span className={astriskClass}>*</span> {errorMessage}</span>
            </label>
            <Input
                className={`fullName  ${className}`}
                type={type}
                name={name}
                placeholder={placeholder}
                required={required}
                autoCapitalize="off"
                autoCorrect="off"
                minLength={minLength}
                maxLength={maxLength}
                value={value}
                onChange={onChange}
            />
        </div>

    )
  
}